import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST, FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST } from "./actionTypes";
import { addUpdatePiaggioItemDetailsFailure, addUpdatePiaggioItemDetailsSuccess, fetchPiaggioItemDetailsListFailure, fetchPiaggioItemDetailsListSuccess } from "./actions";
import { PiaggioItemDetails } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};


function* fetchPiaggioItemDetailsListSaga(action: any) {
  try {
    const response: PiaggioItemDetails[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = (response && response.length > 0 && response[0]?.totalCount)
      ? response[0].totalCount
      : 0;
    yield put(fetchPiaggioItemDetailsListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchPiaggioItemDetailsListFailure(errorMessage));
  }
}

function* addUpdatePiaggioItemDetailsSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdatePiaggioItemDetailsSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdatePiaggioItemDetailsFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* piaggioItemDetailsSaga() {
   yield takeLatest(FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST, fetchPiaggioItemDetailsListSaga);
  yield takeLatest(ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST, addUpdatePiaggioItemDetailsSaga);
}